export default function Footer() {
  return (
    <footer className="site-footer">
      <p className="footer-strong">
        As an Amazon Associate I earn from qualifying purchases.
      </p>
      <p>
        Prices and availability are accurate as of the date shown and are subject to change.
        Any price and availability information displayed on Amazon at the time of purchase applies.
      </p>
      <p style={{color:"rgba(250,247,242,.4)",marginTop:12,fontSize:".75rem"}}>
        Amazon, the Amazon logo, and Amazon Associates are trademarks of Amazon.com, Inc. or its affiliates.
        © {new Date().getFullYear()} BabyFinds
      </p>
    </footer>
  );
}
